import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import CMService from 'services/CMS';
import Slider from "components/Slider";
import Items from './Items';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const CarouselGrid = (props) => {
    let gtmData = [];

    const itemData = props.data ? props.data : null;

    const itemsActive = itemData.banner_offer.filter(element => {
        if((!CMService.validDatesItem(element, itemData.serverDate))) return false
        return element.active === true
    });

    if((itemsActive.length < 4) || !itemData.title) return '';

    useEffect(() => {
        TagManagerService.promotionsImpressions(gtmData);
    }, [])

    const interaction = () => {
        TagManagerService.interaction('Ver más', 'Grilla Carrusel', itemData.title);
    }

    const sliderItems = (data) => {
        let pos = 0;

        let items = data.map((item, i) => {
            pos++
            gtmData.push({
                id: item.imagen.url,
                name: item.imagen.url,
                creative: 'Grilla Carrusel ' + itemData.carouselImageGrid + ' - ' + itemData.title,
                position: 'slot' + pos,
            })

            return (
                <Items item={item} key={i} elementPos={pos} positionGrid={itemData.carouselImageGrid} nameGrid={itemData.title}/>
            )
        });

        return items
    }

    return (
        <section className="carousel-grid">
            <div className="carousel-grid-title-wrap">
                <h3 className="carousel-grid-title" >{itemData.title}</h3>

                {itemData.url && <Link className="new-link carousel-grid-link" to={itemData.url} target={itemData.url_target} onClick={interaction}>Ver más</Link>}
            </div>

            <Slider arrows={true} className="carousel-grid-slider">
                {sliderItems(itemsActive)}
            </Slider>
        </section>
    )
}

CarouselGrid.propTypes = {
    data: PropTypes.object
}

export default CarouselGrid;
